import React from "react";

// Assuming these are your imported brand logos
import image01 from "../../assets/images/image01.png";
import image02 from "../../assets/images/image02.png";
import image03 from "../../assets/images/image03.png";
import image04 from "../../assets/images/image04.png";
import image05 from "../../assets/images/image05.png";
import image06 from "../../assets/images/image06.png";
import image07 from "../../assets/images/image07.png";
import image08 from "../../assets/images/image08.png";
import image09 from "../../assets/images/image09.png";

import image1 from "../../assets/images/image1.png";
import image2 from "../../assets/images/image2.png";
import image3 from "../../assets/images/image3.png";
import image4 from "../../assets/images/image4.png";
import image5 from "../../assets/images/image5.png";
import image7 from "../../assets/images/image7.png";
import image8 from "../../assets/images/image8.png";
import image9 from "../../assets/images/image9.png";

import styles from './AchievementsSection.module.css'

const AchievementsSection = () => {
    // We duplicate the array to ensure a seamless infinite scroll loop
    const logosRow1 = [image01, image02, image03, image04, image05, image06, image07, image08, image09];
    const logosRow2 = [image1, image2, image3, image4, image5, image7, image8, image9];

    return (
        <section className={styles.achievementsContainer} id="achievements">
            <div className={styles.brandWrapper}>
                
                {/* Optional subtle background accent lines for a "track" feel */}
                <div className={styles.trackLines}></div>

                <div className={styles.brandSection}>
                    {/* Row 1 - Scrolling Left */}
                    <div className={styles.slider}>
                        <div className={styles.sliderTrack}>
                            {[...logosRow1, ...logosRow1].map((logo, i) => (
                                <div className={styles.slide} key={`row1-${i}`}>
                                    <img src={logo} alt={`Brand Partner ${i + 1}`} loading="lazy" />
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Row 2 - Scrolling Right */}
                    <div className={`${styles.slider} ${styles.reverse}`}>
                        <div className={styles.sliderTrackReverse}>
                            {[...logosRow2, ...logosRow2].map((logo, i) => (
                                <div className={styles.slide} key={`row2-${i}`}>
                                    <img src={logo} alt={`Brand Partner ${i + 1}`} loading="lazy" />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AchievementsSection;